import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import ReactAudioPlayer from 'react-audio-player'
import { loadLocationWithMessage } from '../../../actions/location'

import Button from '@material-ui/core/Button'
import '../../../styles/assets/css/pages/video_player.css'
import Image from '../../../images/thankyou1.png'
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';

class Intro15 extends Component {
  handleSubmit = (e) => {
    window.location.href = "https://dautenbipolarcenter.org"
  }
  handleBack = (e) => {
    this.props.history.push('/introduction/introduction15')
  }
  render() {
    return (
      <div className="row wrapper">
        <div className="small-12 columns">
          <div className="admin_screen_questionaire box_border_video1">
            <div>
              <div className="img_center title_34 top_space1_1 bottom_space3">
              Thank You!
              </div>
            </div>
            <div className="content1 margin-top1">
              <p><ul>
                <li>Thank you for watching this introduction to FITT-BD.</li>
                <li>For more information about our program, please feel free to contact us at 617-643-9185 or fitt-bd@mgh.harvard.edu.</li>
              </ul></p>
            </div>
            <div className="row">
              <div className="small-12 medium-4 columns back_button3">
                <Button variant="contained" color="primary" disableElevation
                 onClick={this.handleBack} type="button" >
                  Previous
                </Button>
              </div>
              <div className="small-12 medium-4 columns next_button3">
                <Button variant="contained" color="primary" disableElevation
                 onClick={this.handleSubmit} type="submit" >
                  Go Back to Dauten Family Center
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Intro15)
